<agr-page-toolbar
  [pageTitle]="'title' | translate"
  [isEmpty]="!(filteredDefaultSoilAnalyses$ | async)?.length"
  [emptyTitle]="'overviewEmpty' | translate"
  [emptyDescription]="((filterEnabled$ | async) ? 'overviewEmptyFilter' : 'overviewEmptyNoFilter') | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="addDefaultSoilAnalysis()"
>
  <div displayAlways class="wrapper--spacing-horizontal layout--margin-top">
    <agr-filter [config]="filterConfig"></agr-filter>
  </div>
  <mat-table mat-table [dataSource]="pagedDefaultSoilAnalyses$" data-test="crops-table">
    <ng-container matColumnDef="id">
      <mat-header-cell *matHeaderCellDef>{{ 'defaultSoilAnalysis.id' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let defaultSoilAnalysis">{{ defaultSoilAnalysis.id }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="description">
      <mat-header-cell *matHeaderCellDef>{{ 'defaultSoilAnalysis.description' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let defaultSoilAnalysis">{{ defaultSoilAnalysis.description }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="state">
      <mat-header-cell *matHeaderCellDef>{{ 'defaultSoilAnalysis.state' | translate }}</mat-header-cell>
      <mat-cell *matCellDef="let defaultSoilAnalysis">{{ defaultSoilAnalysis.state }}</mat-cell>
    </ng-container>

    <ng-container matColumnDef="stateChange">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let defaultSoilAnalysis">
        <button (click)="changeState(defaultSoilAnalysis)" mat-button data-test="default-soil-analysis-overview__table__state-change">
          <u>{{ defaultSoilAnalysis.state === 'Draft' || defaultSoilAnalysis.state === 'InActive' ? 'Activate' : 'Deactivate' }}</u>
        </button>
      </mat-cell>
    </ng-container>

    <ng-container matColumnDef="actions">
      <mat-header-cell *matHeaderCellDef></mat-header-cell>
      <mat-cell *matCellDef="let defaultSoilAnalysis" class="flex--justify-end">
        <button (click)="editDefaultSoilAnalysis(defaultSoilAnalysis)" mat-icon-button data-test="default-soil-analysis-overview__table__edit">
          <mat-icon>edit</mat-icon>
        </button>
      </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns" data-test="default-soil-analysis-overview__table__row"></mat-row>
  </mat-table>
  <mat-paginator
    #paginator
    [pageSize]="pageSize"
    [pageSizeOptions]="[10, 25, 50]"
    [length]="(filteredDefaultSoilAnalyses$ | async)?.length"
    (page)="page($event)"
    showFirstLastButtons
  ></mat-paginator>
</agr-page-toolbar>
